import { render, staticRenderFns } from "./BiblioOnixImport.vue?vue&type=template&id=210907ef"
import script from "./BiblioOnixImport.vue?vue&type=script&lang=js"
export * from "./BiblioOnixImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports